var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"theme-toggle",attrs:{"type":"button","title":_vm.isDark ? 'Switch to light mode' : 'Switch to dark mode',"aria-label":_vm.isDark ? 'Switch to light mode' : 'Switch to dark mode'},on:{"click":_vm.onToggle}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.isDark ? '☀' : '☾'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }